var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31641 15C6.83305 15 5.383 14.5601 4.14963 13.736C2.91626 12.9119 1.95497 11.7406 1.38731 10.3701C0.819656 8.99968 0.671131 7.49168 0.96052 6.03682C1.24991 4.58197 1.96421 3.2456 3.01311 2.1967C4.062 1.14781 5.39837 0.433503 6.85323 0.144114C8.30809 -0.145275 9.81609 0.00324962 11.1865 0.570907C12.557 1.13856 13.7283 2.09986 14.5524 3.33323C15.3765 4.56659 15.8164 6.01664 15.8164 7.5C15.8164 9.48913 15.0262 11.3968 13.6197 12.8033C12.2132 14.2098 10.3055 15 8.31641 15ZM8.31641 1.07143C7.04496 1.07143 5.80206 1.44846 4.74489 2.15484C3.68771 2.86122 2.86375 3.86523 2.37718 5.03989C1.89062 6.21456 1.76331 7.50713 2.01136 8.75415C2.25941 10.0012 2.87167 11.1466 3.77072 12.0457C4.66977 12.9447 5.81524 13.557 7.06226 13.805C8.30928 14.0531 9.60185 13.9258 10.7765 13.4392C11.9512 12.9527 12.9552 12.1287 13.6616 11.0715C14.3679 10.0144 14.745 8.77145 14.745 7.5C14.745 5.79504 14.0677 4.15991 12.8621 2.95432C11.6565 1.74873 10.0214 1.07143 8.31641 1.07143Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7759 10.7144L7.78125 7.71978V2.67871H8.85268V7.27514L11.5312 9.95907L10.7759 10.7144Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a55a51151affbf58dc957a155586750c.svg";
export { ForwardRef as ReactComponent };